export default "__VITE_ASSET__49f84bb6__"